module.exports = __webpack_public_path__ + "img/mezcladores.22081a14.png";